import React, { HTMLAttributes } from 'react'

import { Button } from '@frame/ui-primitives/button'
import { H4 } from '@frame/ui-primitives/h4'
import { H5 } from '@frame/ui-primitives/h5'

import { addEmploymentMapping } from '@frame/lib/constants'
import useChosenVerifierRequirements from '@frame/lib/hooks/useChosenVerifierRequirements'
import { cn } from '@frame/lib/utils/cn'
import { DataAttribute } from '@frame/types'

type Props = {
  onClick?: () => void
  className?: HTMLAttributes<HTMLDivElement>['className']
}

export function AddEmployerCard({ onClick, className }: Props) {
  const chosenVerifierRequirements = useChosenVerifierRequirements()

  return (
    <div
      className={cn(
        'relative z-30 my-3 flex min-h-[140px] flex-col justify-between rounded-md bg-cobranding-hover p-4',
        className
      )}
    >
      <H5 className="text-left text-xs font-medium text-cobranding">Income History</H5>
      <H4 className="text-left text-base font-semibold text-moss-950">
        Provide {addEmploymentMapping[chosenVerifierRequirements]}
      </H4>
      <Button data-cy={DataAttribute.ADD_EMPLOYER} onClick={onClick} applyCobranding className="mt-2">
        Add employer
      </Button>
    </div>
  )
}
